import { createContext, useContext } from "react";
import { t, tCategory, tIsland, timeAgo } from "./i18n";

export const LangContext = createContext("en");

export const useLang = () => useContext(LangContext);

export const useT = () => {
  const lang = useLang();
  return {
    lang,
    t: (key, fallback) => t(lang, key, fallback),
    tCategory: (cat) => tCategory(lang, cat),
    tIsland: (slug) => tIsland(lang, slug),
    timeAgo: (iso) => timeAgo(iso, lang),
  };
};
